import script from "./Commitment.vue?vue&type=script&setup=true&lang=js"
export * from "./Commitment.vue?vue&type=script&setup=true&lang=js"

import "./Commitment.vue?vue&type=style&index=0&id=28617214&lang=scss"

const __exports__ = script;

export default __exports__